import { Button, Callout, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";
import Detection from "../Detection";

const SENSOR_HISTORY_PAGE_SIZE = 20;

export default function Sensor(props) {
  const [detections, setDetections] = useState([]);
  const [page, setPage] = useState(0);

  function Pagination() {
    return (
      <div className="flexbox-center-center">
        <Button icon="double-chevron-left" onClick={() => setPage(0)} />
        <Button
          icon="chevron-left"
          onClick={() => setPage(Math.max(0, page - 1))}
        />
        <Tag>
          {page + 1}/
          {Math.ceil(detections?.totalCount / SENSOR_HISTORY_PAGE_SIZE)}
        </Tag>
        <Button
          icon="chevron-right"
          onClick={() =>
            setPage(
              Math.min(
                Math.floor(detections?.totalCount / SENSOR_HISTORY_PAGE_SIZE),
                page + 1
              )
            )
          }
        />
        <Button
          icon="double-chevron-right"
          onClick={() =>
            setPage(
              Math.min(
                Math.floor(detections?.totalCount / SENSOR_HISTORY_PAGE_SIZE)
              )
            )
          }
        />
      </div>
    );
  }

  useEffect(() => {
    setPage(0);
  }, [props.id]);

  useEffect(() => {
    if (props.id)
      authenticatedGetFetch(
        `/ow/dc/detections?srv=${props.srv}&sensor=${props.id}&page=${page}&pageSize=${SENSOR_HISTORY_PAGE_SIZE}`,
        (det) => setDetections(det)
      );
  }, [props.id, page]);

  if (props.id)
    return (
      <Callout icon="mobile-video" title={props.uid}>
        {/* <Callout icon="record" title={<Trans>live</Trans>}>
          TODO
        </Callout> */}
        <br />
        <Callout icon="history" title={<Trans>detections history</Trans>}>
          <Pagination />
          {(detections?.data || []).map((d) => (
            <span key={"det" + d.id}>
              <Detection {...d} />
              <br />
            </span>
          ))}
          <Pagination />
        </Callout>
      </Callout>
    );
  else
    return (
      <Callout intent="primary" title={<Trans>sensor</Trans>}>
        <Trans>
          click on a camera to display rsensor history and live detections
        </Trans>
      </Callout>
    );
}
